import React from "react";
import Navbar from "../Navbar/Navbar";
import NavMenu from "../NavMenu/NavMenu";

const Nav = () => {
  return (
    <header className="nav__header">
      <nav>
        <div className="logo">
          <a href="/">Salman Prottoy</a>
        </div>
        <Navbar />
        <NavMenu />
      </nav>
    </header>
  );
};

export default Nav;
